import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthSessionService } from '../services/auth-session.service';
import { TenantContextService } from '../services/tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private readonly authSession: AuthSessionService,
    private readonly router: Router,
    private readonly tenantContext: TenantContextService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const required = (route.data?.['roles'] as string[] | undefined) ?? [];
    if (required.length === 0) {
      return true;
    }

    const roles = this.authSession.getRoles();
    if (roles.includes('ADMIN') || required.some((role) => roles.includes(role))) {
      return true;
    }

    const tenantSegment = this.tenantContext.getTenantRouteSegment();
    void this.router.navigate(['/tenant', tenantSegment, 'login'], {
      queryParams: { returnUrl: this.router.url },
      replaceUrl: true,
    });
    return false;
  }
}
